var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63733 6.136L15.4107 17.864H17.3973L8.624 6.136H6.63733Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2931 0H4.70693C2.1072 0 0 2.1072 0 4.70693V19.2933C0 21.8928 2.1072 24 4.70693 24H19.2933C21.8928 24 24 21.8928 24 19.2931V4.70693C24 2.1072 21.8928 0 19.2931 0ZM14.9419 18.8011L10.9477 13.4605L6.00427 18.8011H4.7336L10.38 12.7013L4.76907 5.19893H9.0936L12.772 10.1173L17.3245 5.19893H18.5952L13.3397 10.8768L19.2664 18.8011H14.9419Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ee30995059676549ceccb681053e55d2.svg";
export { ForwardRef as ReactComponent };